var _style, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1B5EA9;}\r\n\t.st1{enable-background:new    ;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 15,
    cy: 15,
    r: 15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.9,19.2c-0.1-0.2-0.2-0.5-0.2-0.8c-0.1-0.3-0.1-0.6-0.1-0.9c0-0.4,0-0.8,0.1-1.2s0.2-0.7,0.4-1 s0.4-0.6,0.6-0.9s0.5-0.6,0.9-0.8c0.4-0.3,0.7-0.6,0.9-0.8c0.3-0.3,0.5-0.5,0.7-0.8s0.3-0.5,0.4-0.8c0.1-0.3,0.1-0.6,0.1-0.9 c0-0.3-0.1-0.6-0.2-0.8c-0.1-0.2-0.2-0.5-0.4-0.6s-0.4-0.3-0.7-0.4c-0.3-0.1-0.6-0.2-0.9-0.2c-0.7,0-1.5,0.2-2.3,0.5 c-0.8,0.3-1.5,0.8-2.2,1.4V5.8c0.7-0.4,1.5-0.8,2.4-1c0.8-0.2,1.7-0.3,2.6-0.3c0.9,0,1.7,0.1,2.4,0.3c0.7,0.2,1.4,0.5,2,0.9 c0.6,0.4,1,0.9,1.3,1.6c0.3,0.6,0.5,1.4,0.5,2.3c0,0.6-0.1,1.1-0.2,1.5s-0.3,0.9-0.6,1.3c-0.3,0.4-0.6,0.8-0.9,1.2 s-0.8,0.8-1.3,1.2c-0.3,0.3-0.6,0.5-0.9,0.8c-0.2,0.2-0.5,0.5-0.6,0.7c-0.2,0.2-0.3,0.5-0.4,0.7c-0.1,0.3-0.1,0.5-0.1,0.9 c0,0.2,0,0.5,0.1,0.7c0.1,0.2,0.1,0.4,0.2,0.6H12.9z M15,25.3c-0.7,0-1.4-0.2-1.9-0.7c-0.5-0.5-0.7-1-0.7-1.7 c0-0.7,0.2-1.2,0.7-1.6s1.1-0.7,1.9-0.7c0.7,0,1.3,0.2,1.8,0.7c0.5,0.4,0.7,1,0.7,1.6c0,0.7-0.2,1.2-0.7,1.7 C16.3,25.1,15.7,25.3,15,25.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.a055caf0064c650c18b124b76e40fe0a.svg";
export { ForwardRef as ReactComponent };